const getCredentials = () => {
  return JSON.parse(localStorage.getItem('clientData') || '{}')
    ?.credential?.api
}

export {
  getCredentials
}